import {
    FormHelperText
} from '@material-ui/core';
import * as React from 'react';
import { Field } from '@models/field-builder/field';
import {
    Alignment,
    SelectLabel,
    CheckboxStyled
} from '@components/field-builder/styles';

export const FieldCheckBox = (props: Field) => {
    const {
        id,
        setValueMethod,
        label,
        className,
        labelPosition,
        value,
        hidden,
        disabled,
        helperText,
        style
    } = props;

    const handleChange = (event, checked) => {
        if (!setValueMethod) {
            console.error(`No 'setValueMethod' found for the field: ${id}`);
            return;
        }
        setValueMethod(checked);
    }

    return (
        <>
            <Alignment className={className}
                       labelPosition={labelPosition}
                       hidden={hidden}>
                <CheckboxStyled
                    disabled={disabled}
                    onChange={handleChange}
                    checked={value ?? false}
                    value={value?.toString() ?? false}
                    style={style}
                />
                <SelectLabel style={style} onClick={() => handleChange(null, !value)}>{label}</SelectLabel>
            </Alignment>
            <FormHelperText>{helperText}</FormHelperText>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/field-builder/field-checkbox.tsx